import { memo } from 'react';
import { AccessoryDetailProps } from '../../models';
import type { IState } from '../../../../models';
import { useSelector } from 'react-redux';
import Select from '../atom/Select';

const AccessDoorDetails = ({
  accessory,
  onSectionFieldChange,
  onAccessoryFieldChange,
}: AccessoryDetailProps) => {
  const params = useSelector((state: IState) => state.accessDoor.params);
  const handleFieldChange = (value: string | number | null, name: string) => {
    // Use onAccessoryFieldChange for accessory-specific fields like mounting_plane_id
    if (name === 'mounting_plane_id' && onAccessoryFieldChange) {
      onAccessoryFieldChange(value, name);
    } else if (onSectionFieldChange) {
      onSectionFieldChange(value, name);
    }
  };
  return (
    <div className="bot-accessories__detail-card">
      <div className="bot-accessories__detail-grid">
        <div className="bot-accessories__detail-row">
          <span className="bot-accessories__detail-label">Mounting Plane</span>
          <Select
            name="mounting_plane_id"
            options={
              params?.mounting_plane?.filter((e) => e.id === 5 || e.id === 6) ??
              []
            }
            value={accessory?.mounting_plane_id}
            onChange={handleFieldChange}
            className="bot-accessories__detail-select"
            border_bottom={false}
            disabled={accessory.autoAdded}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(AccessDoorDetails);
